var body;

function pause(elem) {
	elem.addClass('ocb-ajax-loading');
	elem.data('paused', true);

	if (!body) {
		body = $('body');
	}

	if (typeof body.data('paused-descendent-count') != 'number') {
		body.data('paused-descendent-count', 0);
	}

	body.addClass('ocb-descendent-ajax-loading');
	body.data('paused-descendent-count', body.data('paused-descendent-count') + 1);
}

function unpause(elem) {
	elem.removeClass('ocb-ajax-loading');
	elem.data('paused', false);

	if (!body) {
		body = $('body');
	}

	if (typeof body.data('paused-descendent-count') != 'number') {
		body.data('paused-descendent-count', 1);
	}

	body.data('paused-descendent-count', body.data('paused-descendent-count') - 1);

	if (body.data('paused-descendent-count') < 1) {
		body.removeClass('ocb-descendent-ajax-loading');
	}
}

function is_paused(elem) {
	return elem.data('paused') === true;
}

export {
	pause,
	unpause,
	is_paused
};
